// The shop interiors' card grid in the farm market's look (design handoff 2026-10-27, "Rynek look"):
// a 1100×568 cream panel, a row of tabs, 4×2 cards of 210×170 with page arrows; on phones one row of
// three bigger cards, like the market (owner 2026-09-30). Pure (node --test).
// Everything sits 30 px above the handoff's numbers (owner 2026-10-27: "slightly higher on the page").
export const SHOP_PANEL = { x: 640, y: 366, w: 1100, h: 568, titleY: 86, tabY: 136, arrowY: 353, pageY: 548, exitY: 597 };
// The greengrocer's smaller panel (handoff 1c).
export const SMALL_PANEL = { x: 640, y: 380, w: 900, h: 420, titleY: 174, exitY: 537 };
export const CARD_W = 210, CARD_H = 170, GAP = 14;
const ROW_Y = [261, 445];                 // the two rows' centres
const TOUCH_ROW_Y = SHOP_PANEL.arrowY;    // phones: the one row sits mid-panel, level with the arrows

export function gridLayout({ touch = false } = {}) {
  return touch
    ? { cols: 3, perPage: 3, scale: 1.3, rowY: [TOUCH_ROW_Y] }
    : { cols: 4, perPage: 8, scale: 1, rowY: ROW_Y };
}

// The centre of the i-th card on a page; a short last row stays left-aligned (the handoff's 6 / 7 cards).
export function cardCenter(i, layout) {
  const rowW = layout.cols * CARD_W + (layout.cols - 1) * GAP;
  const x0 = SHOP_PANEL.x - rowW / 2 + CARD_W / 2;
  return { x: x0 + (i % layout.cols) * (CARD_W + GAP), y: layout.rowY[Math.floor(i / layout.cols)] };
}

export function pageOf(items, page, perPage) {
  const pages = Math.max(1, Math.ceil(items.length / perPage));
  const p = Math.min(Math.max(0, page), pages - 1);
  return { items: items.slice(p * perPage, (p + 1) * perPage), page: p, pages };
}

// Tabs centred on the panel: `step` apart, `w` wide (handoff: 142/150, the furniture shop's two 180/188).
export function tabXs(n, step) {
  return Array.from({ length: n }, (_, i) => SHOP_PANEL.x + (i - (n - 1) / 2) * step);
}

// Keyboard like the market: ←/→ pages, Tab / Shift+Tab the next / previous tab.
export function shopKey(key, shift, { tabs, tab, page, pages }) {
  if (key === 'ArrowRight') return page + 1 < pages ? { tab, page: page + 1 } : null;
  if (key === 'ArrowLeft') return page > 0 ? { tab, page: page - 1 } : null;
  if (key === 'Tab' && tabs.length > 1) {
    const i = Math.max(0, tabs.indexOf(tab)), n = tabs.length;
    return { tab: tabs[(i + (shift ? -1 : 1) + n) % n], page: 0 };
  }
  return null;
}

// What a card shows and whether it can be tapped, as plain data: the scene redraws its cards only when
// this changes (a purchase), not on every state push, so hover / press survive the server's updates.
export function cardsSignature(cards) {
  return JSON.stringify(cards.map(({ key, name, sub, foot, state }) => [key, name, sub, foot, state]));
}

// The clothing shop's "Wszystko": every slot's items in slot order (shopColumns already puts the new wardrobe first).
export function clothingItems(columns, slotIds, tab) {
  return tab === 'wszystko' ? slotIds.flatMap((s) => columns[s] ?? []) : (columns[tab] ?? []);
}
